/** @jsx jsx */
/** @jsxRuntime classic */
import {
  getDashboardsGenericRoute,
  getTasksRoute,
  getHomeRoute,
  getStudioGenericRoute,
  getStudioObjectsRoute,
  getAIAppBuilderRoute
} from "../../utils/routes";
import { AssignedTaskCount } from "./AssignedTaskCount";
import type { LinkProps } from "./types";
import { PermissionTypes } from "@certa/types";
import { Tasks } from "@certa/icons/components/Tasks";
import { App } from "@certa/icons/components/App";
import { Chart } from "@certa/icons/components/Chart";
import { House } from "@certa/icons/components/House";
import { Group } from "@certa/icons/components/Group";
import { ObjectStage } from "@certa/queries/types/studio.types";
import { Wizard } from "@certa/icons/components/Wizard";

// TODO: INTL

export const defaultNavLinks: LinkProps[] = [
  {
    route: getHomeRoute(),
    icon: House,
    label: "Home",
    hideForSuppliers: false,
    id: "home"
  },
  {
    route: getDashboardsGenericRoute(),
    icon: Chart,
    label: "Dashboards",
    alias: [/\/dashboard\/\d+/],
    hideForSuppliers: false,
    checkPermissions: [PermissionTypes.CAN_VIEW_DASHBOARD],
    id: "dashboards"
  },
  {
    route: getTasksRoute(),
    icon: Tasks,
    label: "Tasks",
    extra: AssignedTaskCount,
    hideForSuppliers: false,
    checkPermissions: [PermissionTypes.CAN_VIEW_TASKS],
    id: "tasks"
  },
  {
    route: getStudioGenericRoute(),
    icon: App,
    label: "Studio",
    checkPermissions: [PermissionTypes.CAN_ACCESS_STUDIO],
    hideForSuppliers: true,
    target: "_blank",
    id: "studio"
  }
];

export const studioNavLinks: LinkProps[] = [
  {
    route: getStudioGenericRoute(),
    icon: Group,
    label: "Apps",
    alias: [/\/studio\/apps\/\d+/],
    hideForSuppliers: true,
    id: "studio-apps"
  }
];

export const appBuilderNavLink: LinkProps = {
  route: getAIAppBuilderRoute(),
  icon: Wizard,
  label: "AI App Builder",
  alias: [/\/ai-app-builder/],
  hideForSuppliers: true,
  id: "ai-app-builder"
};

// Remove this when Studio Data Object is Live
export const studioNavLinksWithDataObjectRoute: LinkProps[] = [
  ...studioNavLinks,
  {
    route: getStudioObjectsRoute({ stage: ObjectStage.DRAFT }),
    icon: App,
    label: "Records",
    alias: [/\/studio\/records(\/?(draft|rft|deployed))?(\/\d+)?$/],
    hideForSuppliers: true,
    id: "studio-objects"
  }
];
